<template>
  <section class="container content-padding">
    <div class="row">
      <div class="col-12">
        <h3>Statement ยอดหนี้คงเหลือ</h3>
      </div>
    </div>
    <template v-if="statement && statement.length">
      <div class="row mt-2">
        <div class="col-12 table-responsive">
          <table class="table table-striped" style="font-size: 85%;">
            <thead>
              <tr>
                <th class="text-center">#</th>
                <th class="text-center">วันที่ทำรายการ</th>
                <th class="text-center">รายการ</th>
                <th class="text-right">ยอดหนี้</th>
                <th class="text-right">คงเหลือ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in statement" :key="index" :class="{ 'text-success': record.amount < 0 }">
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ record.created_at | prettyOnlyDate }}</td>
                <td class="text-center">{{ record.detail }}</td>
                <td class="text-right">{{ record.amount }}</td>
                <td class="text-right">{{ record.remain }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-12">
          <h3 class="text-muted">ไม่มีรายการ</h3>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        remain: 0,
        statement: []
      }
    },
    methods: {
      async getStatement () {
        this.reports = []
        const professionalId = this.$route.params.id
        const url = `professionals/${professionalId}/debt-statement`
        const { data } = await axios.get(url)
        if (!data.error) {
          this.remain = data.remain
          this.statement = data.statement
        }
      }
    },
    created () {
      this.getStatement()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalDebt.vue